import React, { useState } from "react";

import { MDBJumbotron, MDBContainer, MDBRow, MDBCol } from "mdbreact";

import "./styles.css";

const MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d15907.777124192058!2d-74.13372118505245!3d4.604000196484457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1strv%2035%2027b%2021%20sur!5e0!3m2!1ses-419!2sco!4v1594436312903!5m2!1ses-419!2sco";

const MAP_EXTERNAL_URL =
  "https://www.google.com/maps/search/?api=1&query=4.604000196484457,-74.13372118505245";

const Contact = () => {
  const [showMap, setShowMap] = useState(false);

  return (
    <MDBJumbotron id="contact" className="container-contact w-100">
      <MDBContainer>
        <h2 className="display-5 text-center mb-5">CONTACTATE CON NOSOTROS</h2>
        <MDBRow>
          <MDBCol size="12" lg="6" className="mb-3">
            <div className="contact-map">
              {showMap ? (
                <iframe
                  src={MAP_EMBED_URL}
                  height="450"
                  width="100%"
                  frameBorder="0"
                  style={{ border: 0 }}
                  allowFullScreen
                  aria-hidden="false"
                  tabIndex="0"
                  title="Ubicación de Ebenezer Proyectos Inmobiliarios"
                ></iframe>
              ) : (
                <div className="contact-map-placeholder">
                  <p className="contact-map-text">
                    Cra 35 27B 21 Sur, Bogotá
                  </p>
                  <button
                    type="button"
                    className="btn btn-project mb-3"
                    onClick={() => setShowMap(true)}
                  >
                    VER MAPA INTERACTIVO
                  </button>
                  <a
                    href={MAP_EXTERNAL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-map-link"
                  >
                    Abrir en Google Maps
                  </a>
                </div>
              )}
            </div>
          </MDBCol>
          <MDBCol size="12" lg="6" className="mb-3 contact-info-col">
            <MDBRow>
              <p style={{ textAlign: "justify" }}>
                EBENEZER PROYECTOS INMOBILIARIOS S.A.S
              </p>
            </MDBRow>

            <MDBRow>
              <p style={{ textAlign: "justify" }}>Nit. 901.089.888-4</p>
            </MDBRow>

            <MDBRow>
              <p style={{ textAlign: "justify" }}>
                Si estas interesado en alguno de nuestros servicios, requieres
                información adicional de los proyectos o deseas agendar una
                visita al apartamento de tu interés, por favor comunicate con
                nosotros por cualquiera de los siguientes medios o a través del
                chat y te responderemos en el menor tiempo posible.
              </p>
            </MDBRow>

            <MDBRow className="pb-3">
              <MDBCol size="1">
                <img
                  className="icon-info"
                  src={"/images/icons/whatsapp.png"}
                  alt="Télefono"
                />
              </MDBCol>
              <MDBCol size="11">
                <span className="align-middle text-info-span">3175075669</span>
              </MDBCol>
            </MDBRow>

            <MDBRow className="pb-3">
              <MDBCol size="1">
                <img
                  className="icon-info"
                  src={"/images/icons/phone.png"}
                  alt="Télefono"
                />
              </MDBCol>
              <MDBCol size="11">
                <span className="align-middle text-info-span">3175075669</span>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol size="1">
                <img
                  className="icon-info"
                  src={"/images/icons/email.png"}
                  alt="Télefono"
                />
              </MDBCol>
              <MDBCol size="11">
                <span className="align-middle text-info-span">
                  ebenezerproyectosinmobiliarios@gmail.com
                </span>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </MDBJumbotron>
  );
};

export default Contact;
